/** Shared look of the Raportti page's panels (ReportGenScreen and its parts). */
import styled from '@emotion/styled';

export const ActionRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 40px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled(Button)`
  background: #4a9eff;
  color: #fff;
  &:hover:not(:disabled) { background: #3a8eef; }
`;

export const SecondaryButton = styled(Button)`
  background: rgba(255,255,255,0.08);
  color: #ccc;
  border: 1px solid #333;
  &:hover:not(:disabled) { background: rgba(255,255,255,0.12); color: #fff; }
`;

export const SectionLabel = styled.h2`
  font-size: 13px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 16px;
`;

export const StatusMessage = styled.div`
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 16px;
  background: ${p => p.$error ? 'rgba(255,68,68,0.1)' : 'rgba(0,255,136,0.1)'};
  color: ${p => p.$error ? '#ff6666' : '#00ff88'};
  border: 1px solid ${p => p.$error ? 'rgba(255,68,68,0.2)' : 'rgba(0,255,136,0.2)'};
`;
